import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toTwoDecimalPlaces } from '../../../helpers';

class CardBalance extends Component {

  static propTypes = {
    // Required
    amount: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,

    // Optional
    className: PropTypes.string,
    amountClassName: PropTypes.string,
    textClassName: PropTypes.string,
    style: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    amountClassName: '',
    textClassName: '',
    style: {},
  }

  render() {
    const {
      amount,
      text,
      className,
      amountClassName,
      textClassName
    } = this.props;

    return (
      <div className={`CardBalance ${className}`}>
        <h1 className={`CardBalance_amount ${amountClassName}`}>
          ${toTwoDecimalPlaces(amount)}
        </h1>
        <h5 className={`CardBalance_text ${textClassName}`}>
          {text}
        </h5>
      </div>
    );
  }
}

export default CardBalance;



// WEBPACK FOOTER //
// ./src/pages/Account/components/CardBalance/CardBalance.js